<template>
  <v-layout>
    <v-flex v-if="loading" class="text-xs-center mt-3">
      <v-progress-circular
        indeterminate
        class="primary--text"
        :size="100"
        :width="1"
      ></v-progress-circular>
    </v-flex>
    <v-flex v-else-if="reports.length" xs12>
      <v-list two-line subheader dense>
        <v-subheader>{{ $tc('reports', reports.length, {count: reports.length}) }}</v-subheader>
        <template v-for="(report, i) in reports">
          <v-list-tile
            :to="`reports/${report.id}`"
            :key="`${report.title}_${report.id}`"
            avatar
          >
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-icon
                  slot="activator"
                  :color="!report.periods.length || !report.sites.length || !report.emails.length
                    ? 'error'
                    : 'success'"
                  @click="e => e.preventDefault()"
                >
                  {{ !report.periods.length || !report.sites.length || !report.emails.length
                    ? 'warning'
                    : 'check_circle' }}
                </v-icon>
                <span>{{ !report.periods.length || !report.sites.length || !report.emails.length ? $tc('invalids', 1, {count: ''}) : $tc('valids', 1, {count: ''}) }}</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ report.title }}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ $tc('sites', report.sites.length, {count: report.sites.length}) }}
                -
                {{ $tc('emails', nbReportsWithoutTargetFirstEmail[i], {count: nbReportsWithoutTargetFirstEmail[i]}) }}
                -
                {{ $tc('periods', report.periods.length, {count: report.periods.length}) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click="e => confirmDelete(e, report)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="i !== reports.length - 1 " :key="i"></v-divider>
        </template>
      </v-list>
    </v-flex>
    <v-flex v-else xs12 sm6 offset-sm3 mt-3>
      <v-card>
        <v-img src="https://s3-eu-west-1.amazonaws.com/targetfirst/img/report.png" height="200px">
        </v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">{{ $t('noReportScheduled') }} 📊</h3>
            <div>{{ $t('noReportScheduledInfos') }}</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="$router.push({path: '/stats/reports/new'})" flat color="secondary">
            {{ $t('create') }} {{ $t('report') }}
            <v-icon right>add</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <!-- Création d'un rapport -->
    <v-fab-transition slot="activator">
      <v-btn
        v-show="!loading"
        color="secondary"
        dark
        fab
        fixed
        bottom
        right
        @click="$router.push({path: '/stats/reports/new'})"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      dialog: false,
      loading: false,
      langs: [
        { text: 'Français', value: 'fr' },
        { text: 'Anglais', value: 'en' }
      ]
    }
  },

  computed: {
    ...mapGetters('_Reports', { reports: 'GET_REPORTS' }),
    /**
     * Retourne le nombre d'emails hors 'targetfirst.com'
     * pour chaque rapport
     */
    nbReportsWithoutTargetFirstEmail () {
      return this.reports.map(r => (
        r.emails.filter(e => e.indexOf('@targetfirst.com') === -1).length
      ))
    }
  },

  async created () {
    this.loading = true
    await this.getReports()
    this.loading = false
  },

  methods: {
    ...mapActions('_Reports', {
      getReports: 'GET_ALL',
      deleteReport: 'DELETE',
      addReport: 'ADD'
    }),

    ...mapActions('_Dialog', { setDialog: 'SET_DIALOG' }),

    confirmDelete (event, report) {
      event.preventDefault()
      if (report.isFull) {
        this.setDialog({
          value: true,
          title: `${this.$t('delete')} ${this.$t('report')} ?`,
          text: `Le rapport "${
            report.title
          }" ne peut être supprimé car il s'agit d'un rapport complet. Veuillez contacter votre gestionnaire de projet Target First.`,
          info: true
        })
      } else {
        this.setDialog({
          value: true,
          title: `${this.$t('delete')} ${this.$t('report')} ?`,
          text: `Le rapport "${
            report.title
          }" sera supprimé définitevement. Cette opération est irreversible !`,
          submit: 'delete',
          model: Object.assign({}, report),
          submitCb: model => this.deleteReport(model)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/reports/Reports.vue